import {
  formlyColumn,
  formlyControl,
  formlyRow,
  TcComponentLookup,
  TcFormlyComponent,
  TcFormlyWrapper,
} from '@tc/core';
import { Component } from '@angular/core';
import {
  closeDialogAndNavigateButtonClicked,
  submitAndCloseDialogButtonClicked,
  TcSmartDetailPopupComponent,
} from '@tc/advanced-components';
import {
  FilterTypesEnum,
  MaterialColor,
  TcConfigTypes,
  TcDataProviderType,
  ListOrder,
} from '@tc/abstract';
import { TcSmartButton } from '@tc/buttons';
import {
  DEFAULT_TC_SMART_FORM_STATE_KEY,
  getTcSmartFormInvalidity,
} from '@tc/smart-form';
import { PermissionAction } from '../../../../../typings/permission-action.enum';
import { PermissionSubject } from '../../../../../typings/permission-subject.enum';
import { CustomRoutes } from '../../../../../typings/custom-routes.enum';
import { printOrganisme } from '../../../store/organismes.actions';

@TcComponentLookup('OrganismesDetailsComponent')
@Component({
  selector: 'app-organismes-details',
  templateUrl: './organismes-details.component.html',
  styleUrls: ['./organismes-details.component.scss'],
})
export class OrganismesDetailsComponent extends TcSmartDetailPopupComponent {
  formStoreKey = 'organismes-grid';

  async setFormConfig() {
    this.dialogConfig.dialogStoreKey = this.formStoreKey;

    this.formConfig = {
      permissionAction: PermissionAction.Create,
      permissionSubject: PermissionSubject.Organismes,
      configType: TcConfigTypes.TcForm,
      storeKey: this.formStoreKey, //Maybe  + -detail
      autoSubmit: false,
      fieldConfigs: [],
      titleConfig: {
        storeKey: this.formStoreKey,
        configType: TcConfigTypes.TcDetailTitle,
        titlePrefix: 'organismes-grid.detail.ficheOrganisme',
        titleProperty: '_id',
        hasGenericSaveButton: true,
        genericSaveButtonAction: submitAndCloseDialogButtonClicked,
        buttonsList: [
          ...(this.data?._id
            ? [
                {
                  label: 'print',
                  color: MaterialColor.Primary,
                  matIcon: 'print',
                  action: printOrganisme,
                  actionPayload: {
                    data: this.data,
                  },
                },
              ]
            : []),
        ],
      },
      headerConfig: {
        configType: TcConfigTypes.TcDetailHeader,
        headerText: 'organismes-grid.detail.organismeDetail',
      },
      footerConfig: {
        configType: TcConfigTypes.TcDetailHeader,
        headerText: this.data?._id ? 'organismes-grid.detail.interactions' : '',
        buttonsList: this.getHeaderButtons(),
      },
    };

    this.initFields();
  }

  initFields() {
    this.formConfig.fieldConfigs = [
      formlyColumn({
        fields: [
          formlyRow({
            fields: [
              formlyControl({
                key: 'supprime',
                defaultValue: false,
                hide: true,
              }),
              formlyControl({
                key: 'nom',
                type: TcFormlyComponent.FormlyInput,
                templateOptions: {
                  required: true,
                  type: 'text',
                },
                lgColSpan: 6,
                xxlColSpan: 3,
              }),
              formlyControl({
                key: 'typologies',
                type: TcFormlyComponent.TcSmartSelect,
                templateOptions: {
                  required: true,
                  multiple: true,
                  compareWith: (o1, o2) => o1?.typologie === o2?.typologie,
                  dataProvider: {
                    configType: TcConfigTypes.TcDataProvider,
                    providerType: TcDataProviderType.BreezeJs,
                    dataSet: 'refTypologie',
                    fields: 'typologie',
                    sortOrder: { key: 'typologie', order: ListOrder.Asc },
                    filter: {
                      filters: [
                        {
                          key: 'utilisable',
                          value: true,
                          filterType: FilterTypesEnum.Equal,
                        },
                      ],
                    },
                  },
                },
                lgColSpan: 6,
                xxlColSpan: 3,
              }),
              formlyControl({
                key: 'compteClef',
                type: TcFormlyComponent.TcSmartSelect,
                templateOptions: {
                  required: false,
                  compareWith: (o1, o2) => o1?._id === o2?._id,
                  dataProvider: {
                    configType: TcConfigTypes.TcDataProvider,
                    providerType: TcDataProviderType.BreezeJs,
                    dataSet: 'refComptesClef',
                    fields: 'compteClef,utilisable',
                    sortOrder: {
                      key: 'compteClef',
                      order: ListOrder.Asc,
                    },
                    filter: {
                      filters: [
                        {
                          key: 'utilisable',
                          value: true,
                          filterType: FilterTypesEnum.Equal,
                        },
                      ],
                    },
                  },
                  labelFieldName: 'compteClef',
                },
                lgColSpan: 6,
                xxlColSpan: 3,
              }),
              formlyControl({
                key: 'groupOrganisme',
                type: TcFormlyComponent.TcAutoComplete,
                templateOptions: {
                  required: false,
                  dataProvider: {
                    configType: TcConfigTypes.TcDataProvider,
                    providerType: TcDataProviderType.BreezeJs,
                    dataSet: 'organismes',
                    fields: 'nom',
                    filter: {
                      filters: [
                        {
                          key: 'supprime',
                          value: 'false',
                          filterType: FilterTypesEnum.Equal,
                        },
                        {
                          key: '_id',
                          value: this.detailId,
                          filterType: FilterTypesEnum.NotEqual,
                        },
                      ],
                    },
                  },
                  clearButtonEnabled: true,
                },
                lgColSpan: 6,
                xxlColSpan: 3,
              }),
            ],
          }),
          formlyColumn({
            fields: [
              formlyRow({
                fields: [
                  formlyControl({
                    key: 'commentaire',
                    type: TcFormlyComponent.FormlyTextarea,
                    templateOptions: {
                      required: false,
                      type: 'text',
                      rows: 5,
                    },
                    colSpan: 12,
                  }),
                ],
              }),
              formlyRow({
                fields: [
                  formlyControl({
                    key: 'pieceJointe',
                    type: TcFormlyComponent.TcFileUploader,
                    templateOptions: {
                      required: false,
                      uploaderConfig: {
                        theme: 'inline',
                        multiple: true,
                        selectable: true,
                        fileDropDisabled: false,
                        maxSize: '1048576',
                        replaceTexts: {
                          selectFileBtn: 'Drop/Select Files',
                        },
                      },
                    },
                    colSpan: 12,
                  }),
                ],
              }),
            ],
            wrappers: [TcFormlyWrapper.ExpansionPanel],

            templateOptions: {
              label: 'autres-details',
            },
            colSpan: 12,
          }),
        ],

        colSpan: 12,
      }),
    ];
  }

  getHeaderButtons(): TcSmartButton[] {
    const headerButtons = [];

    // Add the interlocutors button only if this is an existing organisme
    if (this.data?._id) {
      headerButtons.push({
        label: 'voir-les-interlocuteurs',
        color: MaterialColor.Primary,
        matIcon: 'visibility',
        action: closeDialogAndNavigateButtonClicked,
        actionPayload: {
          storeKey: this.formStoreKey,
          route: `/${CustomRoutes.Interlocuteurs}`,
          queryParams: { 'organisme.nom': this.data.nom },
        },
      });
    }

    headerButtons.push(this.getSaveButton());

    return headerButtons;
  }

  getSaveButton(): TcSmartButton {
    return {
      label: 'enregister',
      color: MaterialColor.Primary,
      matIcon: 'save',
      action: submitAndCloseDialogButtonClicked,
      actionPayload: { storeKey: this.formStoreKey },
      disableStoreKey: this.formStoreKey,
      disableSelector: getTcSmartFormInvalidity,
      smartStateKey: DEFAULT_TC_SMART_FORM_STATE_KEY,
      permissionAction: PermissionAction.Create,
      permissionSubject: PermissionSubject.Organismes,
    };
  }
}
